import type { components } from '@pocapan/shared/types/schema';
import EpisodeBlock from './EpisodeBlock';

type Episode = components['schemas']['ApiV1SceneEpisode'];

interface EpisodePageProps {
  sceneId: string;
  episode: Episode;
  pageIndex: number;
  totalPagesForEpisode: number;
}

const EpisodePage = ({
  sceneId: _sceneId,
  episode,
  pageIndex,
  totalPagesForEpisode
}: EpisodePageProps) => {
  const paragraphs = episode.sceneEpisodeParagraphs ?? [];
  const clampedPageIndex = Math.max(0, Math.min(pageIndex, totalPagesForEpisode - 1));

  return (
    <div
      data-scene-episode-id={episode.sceneEpisodeId ?? ''}
      className="relative h-full min-w-[100vw] w-[100vw] shrink-0"
    >
      <div className="relative h-full w-full overflow-hidden bg-background-light dark:bg-background-dark">
        <div
          className="h-full inline-block align-top"
          style={{
            columnWidth: '100vw',
            columnFill: 'auto',
            columnGap: 0,
            width: `${Math.max(1, totalPagesForEpisode) * 100}vw`,
            transform: `translateX(-${clampedPageIndex * 100}vw)`
          }}
        >
          {paragraphs.length === 0 ? (
            <div className="w-screen px-[17px] py-[16px] animate-pulse">
              <div className="h-[20px] w-[80px] rounded bg-black-opacity-200 dark:bg-white-opacity-200 mb-[12px]" />
              <div className="h-[20px] w-full rounded bg-black-opacity-200 dark:bg-white-opacity-200" />
            </div>
          ) : (
            <EpisodeBlock sceneEpisodeId={episode.sceneEpisodeId ?? ''} paragraphs={paragraphs} />
          )}
        </div>
      </div>
      <div
        className="pointer-events-none absolute inset-y-0 left-0 w-[24px] z-10"
        style={{ background: 'linear-gradient(to right, rgba(0,0,0,0.03), transparent)' }}
      />
      <div
        className="pointer-events-none absolute inset-y-0 right-0 w-[24px] z-10"
        style={{ background: 'linear-gradient(to left, rgba(0,0,0,0.03), transparent)' }}
      />
    </div>
  );
};

export default EpisodePage;
